<template>
    <ViewHomeSlider />
    <div class="bg-ui-bg-elevated py-10">
        <div class="my-container">
            <div class="flex flex-col gap-2 items-start pb-10">
                <h2 class="text-3xl font-bold font-custom">{{ $t('activites') }}</h2>
                <p class="text-lg max-sm:text-base pl-1 font-semibold max-w-4xl">{{ $t('activity.description') }}</p>
            </div>

            <ViewHomeActivities />

            <!-- <section class="py-20 flex flex-col gap-4">
            <h1 class="text-left text-4xl tracking-tight font-black bg-gradient-to-br from-gray-700 to-gray-500 bg-clip-text text-transparent">
                {{ $t('titre') }}
            </h1>

            <p>
                "Bienvenue chez Aire & Montagne. Entre terre et ciel, nous vous offrons l'opportunité de découvrir la montagne dans toute sa
                splendeur. Envolez-vous en parapente biplace pour un moment de pure liberté, ou aventurez-vous en ski hors-piste et randonnée à ski
                pour explorer des espaces vierges. Que vous soyez amateur de grands espaces ou passionné de sensations, nos activités sont conçues
                pour vous offrir des instants d'évasion en harmonie avec la nature."
            </p>
        </section> -->

            <!-- <UInput type="file" size="md" multiple @input="uploadFile"/> -->
            <!-- <div>{{ progress }}</div> -->
        </div>
    </div>
    <div class="min-h-svh bg-ui-bg-elevated pb-20">
        <div class="h-[45svh] min-h-80 lg:min-h-120 bg-lolo-600">
            <div class="my-container h-full flex flex-col gap-4 justify-center pb-10">
                <h1 class="text-3xl lg:text-4xl font-bold font-custom text-white">Nous contacter</h1>
                <div class="text-lg max-sm:text-base pl-1 font-semibold max-w-4xl text-neutral-100">
                    Une question sur nos activités ? Envie de tenter l’aventure ? Écrivez-nous, nous serons ravis d’échanger avec vous !
                </div>
            </div>
        </div>
        <div class="-mt-15 md:-mt-30">
            <div class="max-xl:my-container w-full xl:max-w-[100rem] xl:px-3 mx-auto grid xl:grid-cols-2 gap-10">
                <div class="xl:shadow-lg bg-white border border-ui-border min-h-100 rounded-xl pt-10 pb-12 px-6 sm:px-12">
                    <div class="size-full flex flex-col items-center gap-4">
                        <UIcon class="size-15" name="my:logos1" />
                        <div class="text-2xl font-extrabold font-custom text-neutral-700">Air Et Montagne</div>
                        <div class="text-sm font-semibold text-neutral-700">73620, Les Saisies, Beaufortain</div>
                        <div class="flex mb-6 gap-2">
                            <UPopover class="w-fit">
                                <template #default="{ open }">
                                    <div>
                                        <UTooltip text="Naviguer" :content="{ side: 'top' }" :delay-duration="0">
                                            <UButton
                                                size="xl"
                                                icon="ph:map-pin"
                                                variant="ghost"
                                                :color="open ? 'primary' : 'neutral'"
                                                class="cursor-pointer"
                                            />
                                        </UTooltip>
                                    </div>
                                </template>

                                <template #content>
                                    <div class="bg-ui-bg p-4 m-2 grid gap-2 place-items-center">
                                        <div class="flex items-center gap-2 h-8">
                                            <a
                                                href="utils/contact/geolink?lat=45.7572&lon=6.5393&z=15"
                                                target="_blank"
                                                class="text-sm font-semibold text-lolo-600"
                                            >
                                                Ouvrir la carte
                                            </a>
                                        </div>
                                        <img
                                            class="size-40 block"
                                            :src="`/_icf/qr/code?path=${encodeURIComponent('utils/contact/geolink?lat=45.7572&lon=6.5393&z=15')}`"
                                        />
                                    </div>
                                </template>
                            </UPopover>

                            <UPopover class="w-fit">
                                <template #default="{ open }">
                                    <div>
                                        <UTooltip text="WhatsApp">
                                            <UButton
                                                size="xl"
                                                variant="ghost"
                                                :color="open ? 'primary' : 'neutral'"
                                                icon="ph:whatsapp-logo"
                                                class="cursor-pointer"
                                            />
                                        </UTooltip>
                                    </div>
                                </template>

                                <template #content>
                                    <div class="bg-ui-bg p-4 m-2 grid gap-2 place-items-center">
                                        <div class="flex items-center gap-2 h-8">
                                            <a
                                                href="https://wa.me/message/OHYHLOSDGRCGA1"
                                                target="_blank"
                                                class="text-sm font-semibold text-lolo-600"
                                            >
                                                Message via WhatsApp
                                            </a>
                                        </div>
                                        <img class="size-40 block" :src="`/_icf/qr/code?path=https://wa.me/message/OHYHLOSDGRCGA1`" />
                                    </div>
                                </template>
                            </UPopover>
                            <UPopover>
                                <template #default="{ open }">
                                    <UButton size="xl" variant="ghost" :color="open ? 'primary' : 'neutral'" icon="ph:phone" class="cursor-pointer" />
                                </template>

                                <template #content>
                                    <div class="bg-ui-bg p-4 m-2 grid gap-2 place-items-center">
                                        <div class="flex items-center gap-2 h-8">
                                            <a href="tel:+33743162409" class="text-sm font-semibold text-lolo-600">+33743162409</a>
                                            <UButton variant="ghost" color="lolo" icon="ph:copy" @click="copyPhone" />
                                        </div>
                                        <img
                                            class="size-40 block"
                                            :src="`/_icf/qr/code?path=${encodeURIComponent('utils/contact/tellink?tel=%2B33743162409')}`"
                                        />
                                    </div>
                                </template>
                            </UPopover>
                            <UPopover>
                                <template #default="{ open }">
                                    <UButton
                                        size="xl"
                                        variant="ghost"
                                        :color="open ? 'primary' : 'neutral'"
                                        icon="ph:identification-card"
                                        class="cursor-pointer"
                                    />
                                </template>

                                <template #content>
                                    <div class="bg-ui-bg p-4 m-2 grid gap-2 place-items-center">
                                        <div class="flex items-center gap-2 h-8">
                                            <a href="utils/contact/vcards/airetmontagne.vcf" class="text-sm font-semibold text-lolo-600"
                                                >Importer le contact</a
                                            >
                                        </div>
                                        <img class="size-40 block" :src="`/_icf/qr/code?path=utils/contact/vcards/airetmontagne.vcf`" />
                                    </div>
                                </template>
                            </UPopover>
                        </div>
                        <AirImg
                            class="flex-1 w-full min-h-100 rounded-lg overflow-clip"
                            loading="lazy"
                            :width="334"
                            :height="400"
                            :dpr="[1, 1.8]"
                            src="map1.jpg"
                            :variant="[
                                { breakpoint: 'sm', width: 542 },
                                { breakpoint: 'md', width: 670 },
                                { breakpoint: 'lg', width: 926 },
                                { breakpoint: 'xl', width: 618, height: 484 },
                                { breakpoint: 'xxl', width: 670, height: 484 }
                            ]"
                        />
                        <!-- <iframe
                            class="flex-1 w-full min-h-100 rounded-lg"
                            frameborder="0"
                            scrolling="no"
                            marginheight="0"
                            marginwidth="0"
                            sandbox="allow-forms allow-scripts allow-same-origin"
                            src="https://www.geoportail.gouv.fr/embed/visu.html?c=6.56563,45.74125&z=11&l0=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2::GEOPORTAIL:OGC:WMTS(1)&permalink=yes"
                            allowfullscreen="false"
                        /> -->
                        <!-- <button @click="generateVCard">vcard</button> -->
                    </div>
                </div>

                <div id="formulaire" class="xl:shadow-lg col-span-1 bg-white border border-ui-border min-h-100 rounded-xl pt-10 pb-6 px-6 sm:px-12">
                    <div class="place-items-center text-neutral-600 grid gap-4">
                        <UIcon class="size-13" name="ph:chat-text-fill" />
                        <div class="text-2xl font-extrabold">Formulaire de contact</div>
                    </div>
                    <UForm
                        ref="form"
                        :schema="schema"
                        :state="store.$state"
                        class="pt-12 pb-5 grid grid-cols-2 gap-5 md:gap-5 h-full content-start"
                        @submit="store.submit"
                    >
                        <UFormField label="Votre prenom" name="prenom" required class="col-span-2 sm:col-span-1">
                            <UInput
                                v-model="prenom"
                                variant="soft"
                                :disabled="lock"
                                autocomplete="given-name"
                                class="w-full"
                                size="xl"
                                :ui="{ base: 'bg-neutral-100 hover:bg-lolo-50 focus:bg-lolo-50' }"
                            />
                        </UFormField>
                        <UFormField label="Et nom" name="nom" required class="col-span-2 sm:col-span-1">
                            <UInput
                                v-model="nom"
                                variant="soft"
                                :disabled="lock"
                                autocomplete="family-name"
                                class="w-full"
                                size="xl"
                                :ui="{ base: 'bg-neutral-100 hover:bg-lolo-50 focus:bg-lolo-50' }"
                            />
                        </UFormField>
                        <UFormField label="Adresse email" name="email" required class="col-span-2 sm:col-span-1">
                            <UInput
                                v-model="email"
                                variant="soft"
                                :disabled="lock"
                                type="email"
                                autocomplete="email"
                                class="w-full"
                                size="xl"
                                :ui="{ base: 'bg-neutral-100 hover:bg-lolo-50 focus:bg-lolo-50' }"
                            />
                        </UFormField>
                        <UFormField label="Numero de mobile" name="mobile" class="col-span-2 sm:col-span-1">
                            <UInput
                                v-model="mobile"
                                variant="soft"
                                :disabled="lock"
                                type="tel"
                                autocomplete="tel"
                                class="w-full"
                                size="xl"
                                :ui="{ base: 'bg-neutral-100 hover:bg-lolo-50 focus:bg-lolo-50' }"
                            />
                        </UFormField>
                        <UFormField label="Votre question concerne ?" name="question" required class="col-span-2">
                            <USelect
                                v-model="question"
                                variant="soft"
                                aria-label="Votre question concerne ?"
                                :disabled="lock"
                                :items="questions"
                                class="w-full"
                                size="xl"
                                :ui="{ base: 'bg-neutral-100 hover:bg-lolo-50 focus:bg-lolo-50 focus:outline outline-lolo-200' }"
                            />
                        </UFormField>
                        <UFormField label="Décrire votre demande" name="message" required class="col-span-2" :hint="`${message.length}/1000`">
                            <UTextarea
                                v-model="message"
                                variant="soft"
                                :disabled="lock"
                                size="xl"
                                autoresize
                                :rows="8"
                                :maxrows="16"
                                class="w-full"
                                :ui="{ base: ['bg-neutral-100 hover:bg-lolo-50 focus:bg-lolo-50'] }"
                            />
                        </UFormField>

                        <div class="mt-8 flex gap-6 self-stretch col-span-2 font-bold text-base">
                            <span class="text-red-500">{{ error }}</span>
                            <span class="flex-1" />
                            <UButton
                                :disabled="lock"
                                variant="soft"
                                color="neutral"
                                size="lg"
                                label="Annuler"
                                class="px-5"
                                @click="
                                    () => {
                                        store.$reset();
                                        form?.clear();
                                    }
                                "
                            />
                            <UButton
                                :disabled="lock"
                                loading-auto
                                variant="solid"
                                color="neutral"
                                size="lg"
                                label="Envoyer"
                                type="submit"
                                class="px-5 font-bold"
                            />
                        </div>
                    </UForm>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { useMyContactFormStore } from '~/store/storeContactForm';
definePageMeta({
    expendMobileResa: true,
    saveScrollPosition: true
    // scrollToTop: true,
});

const form = useTemplateRef('form');

const questions = ['Les vols en parapente', 'Le ski de randonnée', 'Les cours de ski', 'Autre'];

const store = useMyContactFormStore();
const { email, message, nom, prenom, question, mobile, schema, error, lock } = storeToRefs(store);

const copyPhone = () => {
    navigator.clipboard
        .writeText('+33743162409')
        .then(() => {
            useToast().add({ description: 'numero de telephone copié', color: 'neutral', icon: 'ph:clipboard-text', close: false, duration: 2000 });
        })
        .catch(err => console.error('Erreur lors de la copie :', err));
};
</script>
